<template> <!-- By default this file acts as a login promt -->
  <v-card :elevation="elev" :dark="config.dark_background" :color="config.background">
    <slot name="toolbar">
    </slot>
    <v-card-title>
      <slot name="title">
        <v-flex class="d-flex justify-center">
          <p class="pa-2">
            Sorry, you must be logged in to do that
          </p>
        </v-flex>
      </slot>
    </v-card-title>

    <v-card-text>
      <slot name="text">
      <v-divider></v-divider>
      </slot>
    </v-card-text>

    <v-card-actions>
      <slot name="actions">
        <v-flex class="d-flex justify-center">
          <v-btn
            class="mb-3"
            :color="config.primary"
            :dark="config.dark_primary"
            large
            elevation="0"
            @click="navigateTo('login')"
          >
            <span>Log In</span>
          </v-btn>
        </v-flex>
      </slot>
    </v-card-actions>
  </v-card>
</template>

<script>
import config from '@/config/config'
export default { // This file is unused right now
  name: 'modal',
  methods: {
    navigateTo (route) {
      this.$router.push(route)
    }
  },
  props: [
    'title',
    'text',
    'actions',
    'elev'
  ],
  data () {
    return {
      config
    }
  }
}
</script>

<style scoped>

</style>